export enum RefreshType {
  EndUsers,
  ScreenNumbers,
}
